import { render } from "./HomeArticlePanel.vue?vue&type=template&id=3a789118&bindings={\"isLoading\":\"setup\",\"articles\":\"setup\"}"
import script from "./HomeArticlePanel.vue?vue&type=script&lang=js"
export * from "./HomeArticlePanel.vue?vue&type=script&lang=js"
script.render = render

export default script